import { createRouter, createWebHistory } from "vue-router";
import { readSession, clearSessionState } from '@/services/session';
import AuthService from '@/services/auth.service';
import store from '@/store';
import authRoutes from "./authRoutes";
import dashboardRoutes from "./dashboardRoutes";
// App routes
import subscriberRoutes from "./subscriberRoutes";
import pushManagementRoutes from "./pushManagementRoutes";
import subscriberSubscriptionReportRoutes from "./subscriberSubscriptionReportRoutes";
import serverListRoutes from "./serverListRoutes";
import ipBundleRoutes from "./ipBundleRoutes";
import ipListRoutes from "./ipListRoutes";

import settingRoutes from "./settingRoutes";
import supportToken from "./supportToken";

const routes = [
  {
    name: "guest",
    path: "/login",
    component: () => import("../components/layouts/Guest.vue"),
    meta: {
      middleware: "guest",
    },
    children: authRoutes,
  },
  {
    name: "base",
    path: "/",
    component: () => import("../components/layouts/Default.vue"),
    meta: {
      middleware: "auth",
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        redirect: { name: "home" },
      },
      ...dashboardRoutes,
      ...subscriberRoutes,
      ...pushManagementRoutes,
      ...subscriberSubscriptionReportRoutes,
      ...serverListRoutes,
      ...ipBundleRoutes,
      ...ipListRoutes,
      ...settingRoutes,
      ...supportToken,
    ],
  },
];

const router = createRouter({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  let authenticated = false;
  try { authenticated = Boolean((await readSession()).authenticated); } catch { /* Protected routes require a verified session. */ }
  if (authenticated) {
    try {
      const profile = await AuthService.getProfile();
      await store.dispatch('setUser', profile.data.result.user);
      await store.dispatch('changLoginStatus', true);
    } catch {
      authenticated = false;
      await AuthService.logout().catch(() => {});
      clearSessionState();
    }
  }
  if (!authenticated) {
    await store.dispatch('setUser', null);
    await store.dispatch('changLoginStatus', false);
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!authenticated) {
      next({
        name: "login",
      });
    } else {
      next();
    }
  } else {
    if (to.name == "login") {
      if (!authenticated) {
        next();
      } else {
        next({
          name: "home",
        });
      }
    } else {
      next();
    }
  }
});

export default router;
